"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledFilterTypography = exports.StyledDatePicker = exports.StyledDatePickerWrapper = exports.StyledButtonWrapper = exports.StyledInputsWrapper = exports.StyledItemWrapper = exports.StyledInitialColumnWrapper = exports.StyledFilterRowWrapper = void 0;
const ui_components_1 = require("@groupby/ui-components");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledFilterRowWrapper = styled_components_1.default.div `
  flex: 1;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
  box-sizing: border-box;
  gap: ${({ theme }) => theme.spacing(2)};
  margin: .7rem 0rem;
  padding: ${({ theme: { spacing } }) => spacing(0, 2)};

  .and-or-toggle {
    height: ${({ theme }) => theme.spacing(5.25)};
  }
`;
exports.StyledInitialColumnWrapper = styled_components_1.default.div `
  width: ${({ theme }) => theme.spacing(13.125)};
`;
exports.StyledItemWrapper = styled_components_1.default.div `
  font-size: 1.1rem;
  flex: 2;
  
  &.value {
    flex: 3;
  }

  &.text {
    font-size: 1.4rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;
exports.StyledInputsWrapper = styled_components_1.default.div `
  flex: 1;
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(2)};
`;
exports.StyledButtonWrapper = styled_components_1.default.div `
  display: flex;
  justify-content: center;
  align-items: center;
`;
exports.StyledDatePickerWrapper = styled_components_1.default.div `
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  flex: 1;

  font-size: 1.1rem;
`;
exports.StyledDatePicker = styled_components_1.default.div `
  width: 100%;

  div:first-child {
    width: 100%;
  }

  .react-datepicker-wrapper {
    width: 100%;
  }

  .MuiFormControl-root {
    width: 100%;
  }
`;
// export const StyledFilterRow = styled(FilterRow)`
//   margin-top: 0.6rem;
// `;
exports.StyledFilterTypography = (0, styled_components_1.default)(ui_components_1.Typography) `
  font-size: ${({ theme }) => theme.spacing(2.25)};
`;
